import { useWeb3React } from '@web3-react/core'
import { useTokenAllowance } from '~/hooks/useTokenAllowance'
import { useAllowanceTarget } from '~/state/dex/hooks'

export const useLimitOrderAllowance = (token: ERC20Token) => {
  const { account } = useWeb3React()
  const allowanceTarget = useAllowanceTarget()

  return useTokenAllowance(token, account, allowanceTarget)
}
